import { Modal } from 'antd';
import get from 'lodash/get';
import OrganizationModalForm from './GetOrganizationModalPageOneComponent.jsx';

function GetOrganizationModal(props) {
	const { error, theme, visible, page, closeModal, setPageTwo } = props;
	return (
		<Modal
			title={'Enter Company Code'}
			destroyOnClose={true}
			footer={null}
			open={visible}
			width={500}
			onCancel={closeModal}
			onOk={null}
		>
			{page === 1 && (
				<OrganizationModalForm
					samlData={get(props, 'samlData')}
					error={error}
					theme={theme}
					setPageTwo={setPageTwo}
					closeModal={closeModal}
					page={page}
				/>
			)}
		</Modal>
	);
}

export default GetOrganizationModal;
